import { render, staticRenderFns } from "./SimulasiTma.vue?vue&type=template&id=5f790d95&"
import script from "./SimulasiTma.vue?vue&type=script&lang=js&"
export * from "./SimulasiTma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports